import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { PanelPage } from '../../components/pages/pages';
import OneClickButton from '../../components/form/button';
import DualList from '../../components/pages/DualList';
import Form from '../../components/form/form';
import { generateReport } from '../../app/store/actions/reports';
import FilterDefault from '../../components/filters/FilterDefault';
import { returnFiltersByRules } from './utils';
import ROUTES from '../../config/routes';
import ReportsBackgroundModal from '../../components/pages/reportsBackgroundModal';

class ReportAdminGeneralRange extends React.PureComponent {
  constructor() {
    super();

    this.breadcrumb = [
      {
        value: (<>
          <i className="fas fa-home fa-fw m-t-10 m-r-5" />
          {' '}
          { I18n.t('BEE12' /* Início */)}
                </>),
      },
      { value: I18n.t('BEE47' /* Relatórios */) },
      { value: I18n.t('BEE1389' /* Cadastros */) },
      { value: I18n.t('BEE14' /* Gerais */) },
      { value: I18n.t('BEE1346' /* Range x Endereços x Usuários */), active: true },
    ];

    this.options = [
      {
        label: I18n.t('BEE1754' /* Código Range */),
        value: 'code',
      }, {
        label: I18n.t('BEE2369' /* Nome Range */),
        value: 'name',
      }, {
        label: I18n.t('BEE145' /* Filial */),
        value: 'branchCode',
      }, {
        label: I18n.t('BEE1664' /* Limite de Produto por Onda */),
        value: 'limitProductsWave',
      }, {
        label: I18n.t('BEE1755' /* Código Endereço */),
        value: 'storageAddressesCode',
      }, {
        label: I18n.t('BEE1' /* Usuário */),
        value: 'usersRangesCode',
      }, {
        label: I18n.t('BEE1749' /* Nome Usuário */),
        value: 'usersRangesName',
      },
    ];

    this.state = {
      selected: [],
      codeFrom: '',
      codeTo: '',
      nameFrom: '',
      nameTo: '',
      branchCodeFrom: '',
      branchCodeTo: '',
      storageAddressesCodeFrom: '',
      storageAddressesCodeTo: '',
      usersRangesCodeFrom: '',
      usersRangesCodeTo: '',
      usersRangesNameFrom: '',
      usersRangesNameTo: '',
    };
  }

  onChangeDualList = (selected) => {
    this.setState({ selected });
  };

  setValue = async (attr, value, label) => {
    this.setState({
      [`${attr}`]: value,
    });
  };

  onGenerateSpreadsheet = () => {
    const {
      selected,
      codeFrom,
      codeTo,
      nameFrom,
      nameTo,
      branchCodeFrom,
      branchCodeTo,
      storageAddressesCodeFrom,
      storageAddressesCodeTo,
      usersRangesCodeFrom,
      usersRangesCodeTo,
      usersRangesNameFrom,
      usersRangesNameTo,
    } = this.state;
    const { location } = this.props;

    const headers = selected.map((it) => ({ ...(this.options.find((itb) => itb.value === it) || {}) }));

    const filters = returnFiltersByRules([
      ['code', { type: 'between', value: [codeFrom, codeTo] }],
      ['name', { type: 'between', value: [nameFrom, nameTo] }],
      ['branchCode', { type: 'between', value: [branchCodeFrom, branchCodeTo] }],
      ['$code', {
        type: 'between',
        value: [storageAddressesCodeFrom.toLocaleUpperCase(), storageAddressesCodeTo.toLocaleUpperCase()],
        instance: 'StorageAddress',
        as: 'storageAddress',
      }],
      ['login', {
        type: 'between', value: [usersRangesCodeFrom, usersRangesCodeTo], instance: 'User', as: 'usersRanges->user',
      }],
      ['$name', {
        type: 'between', value: [usersRangesNameFrom, usersRangesNameTo], instance: 'User', as: 'usersRanges->user',
      }],
    ]);
    this.props.generateReport(
      I18n.t('BEE1346' /* Range x Endereços x Usuários */).toLowerCase(),
      'xlsx',
      location.pathname,
      headers,
      filters,
    );
  };

  onSelectFilter = (newState) => this.setState({ ...newState });

  render() {
    const {
      selected,
      codeFrom,
      codeTo,
      nameFrom,
      nameTo,
      branchCodeFrom,
      branchCodeTo,
      storageAddressesCodeFrom,
      storageAddressesCodeTo,
      usersRangesCodeFrom,
      usersRangesCodeTo,
      usersRangesNameFrom,
      usersRangesNameTo,
    } = this.state;

    const { location = {} } = this.props;

    return (
      <PanelPage
        breadcrumb={this.breadcrumb}
        title={`${I18n.t('BEE528' /* Relatório */)} - ${I18n.t('BEE1346' /* Range x Endereços x Usuários */)}`}
        wikiHelp={ROUTES.REPORT_HELP}
        content={(
          <div style={{ marginLeft: 20, marginRight: 20 }}>
            <FilterDefault stateToSave={this.state} route={location.pathname} onSelectFilter={this.onSelectFilter} />
            <div className="d-flex mb-md-4 mb-4 mt-4" />
            <DualList
              id="dualselect"
              options={this.options}
              selected={selected}
              onChange={this.onChangeDualList}
              preserveSelectOrder
              showOrderButtons
              showHeaderLabels
            />
            <div className="d-flex align-items-center mb-md-3 mb-1 mt-5">
              <h1 className="page-header mb-0">
                {I18n.t('BEE546' /* Filtros */)}
              </h1>
            </div>
            <hr />
            <div style={{ marginTop: 30 }}>
              <Form
                noPanel
                leftType
                setValue={this.setValue}
                inputs={(formContext) => ([
                  formContext.createInputRange(
                    { from: codeFrom, to: codeTo },
                    { from: 'codeFrom', to: 'codeTo' },
                    `${I18n.t('BEE1754' /* Código Range */)}:`,
                    { from: '', to: 'Z'.repeat(10) },
                  ),
                  formContext.createInputRange(
                    { from: nameFrom, to: nameTo },
                    { from: 'nameFrom', to: 'nameTo' },
                    `${I18n.t('BEE2369' /* Nome Range */)}:`,
                    { from: '', to: 'Z'.repeat(10) },
                  ),
                  formContext.createInputRange(
                    { from: branchCodeFrom, to: branchCodeTo },
                    { from: 'branchCodeFrom', to: 'branchCodeTo' },
                    `${I18n.t('BEE1994' /* Código Filial */)}:`,
                    { from: '', to: 'Z'.repeat(10) },
                  ),
                  formContext.createInputRange(
                    {
                      from: storageAddressesCodeFrom.toLocaleUpperCase(),
                      to: storageAddressesCodeTo.toLocaleUpperCase(),
                    },
                    { from: 'storageAddressesCodeFrom', to: 'storageAddressesCodeTo' },
                    `${I18n.t('BEE1755' /* Código Endereço */)}:`,
                    { from: '', to: 'Z'.repeat(10) },
                  ),
                  formContext.createInputRange(
                    { from: usersRangesCodeFrom, to: usersRangesCodeTo },
                    { from: 'usersRangesCodeFrom', to: 'usersRangesCodeTo' },
                    `${I18n.t('BEE1' /* Usuário */)}:`,
                    { from: '', to: 'Z'.repeat(10) },
                  ),
                  formContext.createInputRange(
                    { from: usersRangesNameFrom, to: usersRangesNameTo },
                    { from: 'usersRangesNameFrom', to: 'usersRangesNameTo' },
                    `${I18n.t('BEE1749' /* Nome Usuário */)}:`,
                    { from: '', to: 'Z'.repeat(10) },
                  ),
                ])}
              />
            </div>
            <ReportsBackgroundModal />
          </div>
        )}
        footerContent={(
          <OneClickButton
            type="button"
            style={{ width: 'auto', padding: 10 }}
            className="btn btn-primary p-5 m-5"
            onClick={this.onGenerateSpreadsheet}
          >
            {I18n.t('BEE544' /* Gerar Planilha */)}
          </OneClickButton>
        )}
      />
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
  generateReport: (
    nameDoc,
    type,
    route,
    columns,
    filters,
  ) => dispatch(generateReport(nameDoc, type, route, columns, filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportAdminGeneralRange);
